
import React from 'react';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

const MultiCarousel = (props) => {
    return <OwlCarousel slideBy= {1} items={props.items?props.items:3} className={props.className?props.className + ' owl-theme':'owl-theme N_research_content'} loop={props.noloop?false:true} margin={10} nav>
        {props.children && props.children.map((data)=>{
            return data
        })}
    </OwlCarousel>
}   
export default MultiCarousel;

